/**
 * rem 自适应方案
 *
 * 配合 postcss-pxtorem（构建时自动 px → rem），在运行时按视口宽度缩放 html font-size。
 *
 * 设计基准：在 designWidth 宽度下，1rem = baseFontSize px
 *   - 1440px 视口 → 1rem = 100px（设计稿 1:1 显示）
 *   - 768px 视口  → 1rem ≈ 53px（自动等比缩小）
 *   - 375px 视口  → 1rem ≈ 26px（自动等比缩小）
 *
 * 超出 [minWidth, maxWidth] 范围不再缩放，避免极端值。
 */

interface SetRemConfig {
  designWidth?: number
  baseFontSize?: number
  maxWidth?: number
  minWidth?: number
}

const setRem = (config: SetRemConfig = {}): void => {
  const {
    designWidth = 1440,
    baseFontSize = 100,
    maxWidth = 1440,
    minWidth = 375,
  } = config

  const setRemSize = () => {
    const docEl = document.documentElement
    const clientWidth = docEl.clientWidth
    // 限制范围，避免极端缩放
    const width = Math.min(Math.max(clientWidth, minWidth), maxWidth)
    const remSize = (width / designWidth) * baseFontSize
    docEl.style.fontSize = `${remSize}px`
  }

  setRemSize()
  window.addEventListener('resize', setRemSize)
  // iOS Safari 回退/缓存页面时重新设置
  document.addEventListener('pageshow', (e: Event) => {
    if ((e as PageTransitionEvent).persisted) setRemSize()
  })
}

export default setRem
